// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Radio_checkbox__MQW_d"};